var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-down-container"
  }, [_c('div', {
    staticClass: "data-item media_font_size_50"
  }, [_c('span', {
    staticClass: "media_font_size_30"
  }, [_vm._v(_vm._s(_vm.$t('exhibitors.invitation2024')))]), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "media_font_size_50",
    attrs: {
      "href": "https://vrshow-1255573444.cos.ap-guangzhou.myqcloud.com/autoShow/exhibitor/2025%E5%B9%BF%E5%B7%9E%E8%BD%A6%E5%B1%95%E6%8B%9B%E5%B1%95%E5%87%BD.pdf",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('public.download')))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-download media_font_size_50"
  })])])])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2444077c","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/exhibitor/components/exhibitData.vue
// module id = null
// module chunks = 